import React from "react";
import { isXSell } from "@tvg/sh-utils/mobileUtils";
import MyBetsModalFilter from "../filter";
import HeaderFeedbackBanner from "../feedbackBanner";
import { MyBetsTopStickyAreaProps } from "./types";
import AlertXsell from "../alertXsell";

const MyBetsTopStickyArea = ({
  isPastPerformanceOpen,
  showBannerFeedback
}: MyBetsTopStickyAreaProps) => (
  <>
    {isXSell() && <AlertXsell />}
    {showBannerFeedback && <HeaderFeedbackBanner />}
    {!isPastPerformanceOpen ? <MyBetsModalFilter /> : null}
  </>
);

export default MyBetsTopStickyArea;
